import { render, staticRenderFns } from "./MealItems.vue?vue&type=template&id=56fab094&scoped=true"
import script from "./MealItems.vue?vue&type=script&lang=js"
export * from "./MealItems.vue?vue&type=script&lang=js"
import style0 from "./MealItems.vue?vue&type=style&index=0&id=56fab094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fab094",
  null
  
)

export default component.exports